import { ListingFiltersValues } from '../ui/table/types';

import { CalendarEventViewModel } from '@trnsact/trnsact-shared-types';

export enum CalendarView {
  Month = 'month',
  Week = 'week',
  Day = 'day',
  Table = 'table',
}

export enum EventCardMode {
  Read = 'read',
  Write = 'write',
}

export interface CalendarEventCardProps {
  onSwitchMode: VoidFunction;
  handleClose: VoidFunction;
  event: CalendarEventViewModel;
}

export interface CalendarViewComponentProps {
  date: Date;
  onNavigate: (date: Date) => void;
  userProfileId?: string | null;
}

export interface QuickFilterConfig {
  label: string;
  tooltip?: string;
  value: Partial<ListingFiltersValues['filters']>;
}
